import {Box} from "@mui/system";
import DataSource from "../Utilities/DataSources/DataSource";
import styles from "../organizationMainStyles";
import {getAccessibilityMode, getLabel} from "../Utilities/organizationSettingsUtils";
import useGetDataSourceHandleInfo from "../hooks/useGetDataSourceHandleInfo";
import useGetTrendsDataSourceHandles from "../hooks/useGetTrendsDataSourceHandles";
import {fragmentId} from "../Utilities/organizationSettingsConstants";
import _ from "lodash";
import NoDataView from "../EmptyStates/NoDataView";
import React from "react";
import DataSourcesEmptyState from "../EmptyStates/DataSourcesEmptyState";

export default function DataSources({organizationId, organizationTrendsId}) {
    const label = getLabel(fragmentId.DATA_SOURCES);
    const {handleInfo, loading} = useGetDataSourceHandleInfo(organizationId);
    const {trendsHandles} = useGetTrendsDataSourceHandles(organizationTrendsId);
    const mode = getAccessibilityMode();

    if(_.isEmpty(organizationId) && _.isEmpty(handleInfo)) {
        return <NoDataView />
    }

    if(loading) {
        return (
            <Box sx={styles.sectionWrapper}>
                <DataSourcesEmptyState/>
            </Box>
        )
    }

    const findTrendsHandle = (handle) => {
        if (!handle.trendsId || _.isEmpty(trendsHandles)) {
            return null;
        }
        return trendsHandles.find((trendsHandle) => trendsHandle.id === handle.trendsId) || null;
    };

    return (
        <Box sx={styles.sectionWrapper}>
            {
                handleInfo.items && handleInfo.items.map((handle) =>
                    <DataSource
                        key={handle.id}
                        handle={handle}
                        trendsHandle={findTrendsHandle(handle)}
                        mode={mode}
                        label={label}
                    />
                )
            }
        </Box>
    )
}